import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getAvailableEquipment(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,
		dtConfig[ModulesMap.EQUIPMENT].getAvailableEquipment,
		{
			urlParams: {
				companyId,
			},
		},
		cashedPayload
	)
}
function getBasedEquipment(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,
		dtConfig[ModulesMap.EQUIPMENT].getBasedEquipment,
		{
			urlParams: {
				companyId,
			},
		},
		cashedPayload
	)
}
function getExtendedEquipment(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,
		dtConfig[ModulesMap.EQUIPMENT].getExtendedEquipment,
		{
			urlParams: {
				companyId,
			},
		},
		cashedPayload
	)
}
function getFullEquipment(companyId, cashedPayload) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,
		dtConfig[ModulesMap.EQUIPMENT].getFullEquipment,
		{
			urlParams: {
				companyId,
			},
		},
		cashedPayload
	)
}

function getEquipment(companyId, equipmentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,dtConfig[ModulesMap.EQUIPMENT].getEquipment, {
		urlParams: {
			companyId,
			equipmentId,
		},
	})
}

function getPreviewEquipment(companyId, equipmentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,dtConfig[ModulesMap.EQUIPMENT].getPreviewEquipment, {
		urlParams: {
			companyId,
			equipmentId,
		},
	})
}

function getPopupEquipment(companyId, equipmentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,dtConfig[ModulesMap.EQUIPMENT].getPopupEquipment, {
		urlParams: {
			companyId,
			equipmentId,
		},
	})
}

function createEquipment(companyId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,dtConfig[ModulesMap.EQUIPMENT].createEquipment, {
		urlParams: {
			companyId,
		},
		...data,
	})
}

function patchEquipment(companyId, equipmentId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,dtConfig[ModulesMap.EQUIPMENT].patchEquipment, {
		urlParams: {
			companyId,
			equipmentId,
		},
		...data,
	})
}

function putEquipment(companyId, equipmentId, data) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,dtConfig[ModulesMap.EQUIPMENT].putEquipment, {
		urlParams: {
			companyId,
			equipmentId,
		},
		...data,
	})
}

function deleteEquipment(companyId, equipmentId) {
	return dataTransferWrap(
		ModulesMap.EQUIPMENT,dtConfig[ModulesMap.EQUIPMENT].deleteEquipment, {
		urlParams: {
			companyId,
			equipmentId,
		},
	})
}

export default {
	getAvailableEquipment,
	getBasedEquipment,
	getExtendedEquipment,
	getFullEquipment,
	getPreviewEquipment,
	getPopupEquipment,
	createEquipment,
	patchEquipment,
	putEquipment,
	deleteEquipment,
	getEquipment,
}
